export const Tiktok = () => {
  return (
    <div className="flex justify-center bg-gradient-to-br from-cyan-200 via-blue-50 to-pink-300">
      <div className=" w-[1920px] pb-[130px] pt-[9.69em] flex gap-[120px] px-[15rem] relative">
        <div className="flex w-full h-full">
          <div className="flex-1 ">
            <div className="w-[600px] mt-[35px] justify-start text-zinc-800 text-5xl font-bold font-['Alibaba_PuHuiTi_3.0'] leading-[60px]">
              TikTok全场景网络解决方案
            </div>
            <div className="flex mt-[40px]">
              <img
                className="w-[32px] h-[32px] mr-[18px]"
                src="/imgs/tiktok/home-1.svg"
              />
              <div className="w-80 justify-start text-zinc-800 text-2xl font-normal font-['Alibaba_PuHuiTi_3.0'] leading-7">
                TK全球直播加速专线
              </div>
            </div>

            <div className="flex mt-[22px]">
              <img
                className="w-[32px] h-[32px] mr-[18px]"
                src="/imgs/tiktok/home-2.svg"
              />
              <div className="w-80 justify-start text-zinc-800 text-2xl font-normal font-['Alibaba_PuHuiTi_3.0'] leading-7">
                TK短视频运营/养号
              </div>
            </div>

            <div className="flex mt-[22px]">
              <img
                className="w-[32px] h-[32px] mr-[18px]"
                src="/imgs/tiktok/home-3.svg"
              />
              <div className="w-80 justify-start text-zinc-800 text-2xl font-normal font-['Alibaba_PuHuiTi_3.0'] leading-7">
                TK全球中视频创作者基金
              </div>
            </div>

            <div className="flex mt-[22px]">
              <img
                className="w-[32px] h-[32px] mr-[18px]"
                src="/imgs/tiktok/home-4.svg"
              />
              <div className="w-80 justify-start text-zinc-800 text-2xl font-normal font-['Alibaba_PuHuiTi_3.0'] leading-7">
                TK全球视频带货
              </div>
            </div>
            <div className="rounded-[10px] bg-gradient-to-r from-[#64B7FF] via-[#89ABFF] to-[#B99BFF] shadow-[0_7px_14px_0_rgba(0,0,0,0.10)] inline-flex p-[16px_50px] justify-center items-center gap-[10px] mt-[30px] text-white font-['Alibaba_PuHuiTi_3.0'] text-[26px] font-bold leading-none">
              立即咨询
            </div>
            {/* <div className="mt-[40px] px-12 py-4 bg-gradient-to-br from-blue-400 via-blue-300 to-purple-400 rounded-[10px] shadow-[0px_7px_14px_0px_rgba(0,0,0,0.10)] inline-flex justify-center items-center gap-2.5">
              <div className="justify-start text-white text-2xl font-bold font-['Alibaba_PuHuiTi_3.0']">
                立即咨询
              </div>
            </div> */}
          </div>

          <img src="/imgs/tiktok/home.png" className="w-[700px] h-[460px]" />
        </div>
      </div>
    </div>
  );
};
